module.exports = __webpack_public_path__ + "img/integrador_de_dados_img3.e54a7226.jpg";